// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Nzli","legacyBtn":"MutateMid_legacyBtn__UX183"};